import * as Yup from "yup";
import i18next from "../../i18n/i18n";

export const SIGN_UP_FIELD_LIMITS = {
  name: 30,
  email: 50,
  phone: 15,
  password: 128,
};

export const NAME_ALLOWED_REGEX = /^\p{L}[\p{L}\p{M} .'-]*$/u;
export const PHONE_ALLOWED_REGEX = /^[0-9]{7,15}$/;
const PASSWORD_ALLOWED_REGEX = /^[A-Za-z0-9@$!%*?&]+$/;
const PASSWORD_REPEATING_REGEX = /(.)\1{2,}/;
const PASSWORD_SEQUENCE_REGEX =
  /(?:012|123|234|345|456|567|678|789|987|876|765|654|543|432|321|210)/;

const validationMessage = (key, options) => () =>
  i18next.t(`homeAuthPages:${key}`, options);

const nameValidation = (fieldKey, requiredKey) =>
  Yup.string()
    .trim()
    .required(validationMessage(requiredKey))
    .matches(
      NAME_ALLOWED_REGEX,
      () => i18next.t("homeAuthPages:name_invalid_characters", {
        field: i18next.t(`homeAuthPages:${fieldKey}`),
      })
    )
    .max(
      SIGN_UP_FIELD_LIMITS.name,
      () => i18next.t("homeAuthPages:name_max_length", {
        field: i18next.t(`homeAuthPages:${fieldKey}`),
        count: SIGN_UP_FIELD_LIMITS.name,
      })
    );

const phoneValidation = Yup.string()
  .nullable()
  .notRequired()
  .matches(PHONE_ALLOWED_REGEX, {
    message: validationMessage("enter_valid_phone"),
    excludeEmptyString: true,
  });

const emailValidation = Yup.string()
  .trim()
  .required(validationMessage("email_required"))
  .email(validationMessage("invalid_email"))
  .max(
    SIGN_UP_FIELD_LIMITS.email,
    validationMessage("email_max_length", {
      count: SIGN_UP_FIELD_LIMITS.email,
    })
  );

const passwordValidation = Yup.string()
  .required(validationMessage("password_required"))
  .max(
    SIGN_UP_FIELD_LIMITS.password,
    validationMessage("password_max_length", {
      count: SIGN_UP_FIELD_LIMITS.password,
    })
  )
  .test(
    "password-requirements",
    validationMessage("password_requirements"),
    (value = "") =>
      value.length >= 8 &&
      /[A-Z]/.test(value) &&
      /[a-z]/.test(value) &&
      /\d/.test(value) &&
      /[@$!%*?&]/.test(value) &&
      PASSWORD_ALLOWED_REGEX.test(value) &&
      !PASSWORD_REPEATING_REGEX.test(value) &&
      !PASSWORD_SEQUENCE_REGEX.test(value)
  );

export const state = {
  first_name: "",
  last_name: "",
  country_code: "+91",
  phone_no: "",
  email: "",
  password: "",
  confirm_password: "",
};
const restrictedDomains = [
  "gmail.com",
  "yahoo.com",
  "outlook.com",
  "hotmail.com",
];
export const schema = Yup.object().shape({
  first_name: nameValidation("first_name", "first_name_required"),
  last_name: nameValidation("last_name", "last_name_required"),
  country_code: Yup.string().notRequired(),
  phone_no: phoneValidation,

  email: emailValidation
    .test(
      "restricted-domain",
      validationMessage("company_email_join_org"),
      (value) => {
        if (!value) return true;
        const domain = value.split("@")[1];
        return domain && !restrictedDomains.includes(domain);
      }
    ),

  password: passwordValidation,
  confirm_password: Yup.string()
    .required(validationMessage("confirm_password_required"))
    .oneOf([Yup.ref("password")], validationMessage("passwords_mismatch")),
});

export const schema3 = Yup.object().shape({
  first_name: nameValidation("first_name", "first_name_required"),
  last_name: nameValidation("last_name", "last_name_required"),
  country_code: Yup.string().notRequired(),
  phone_no: phoneValidation,

  email: emailValidation,

  password: passwordValidation,
  confirm_password: Yup.string()
    .required(validationMessage("confirm_password_required"))
    .oneOf([Yup.ref("password")], validationMessage("passwords_mismatch")),
});
